import { render, staticRenderFns } from "./ActivityForm.vue?vue&type=template&id=2c868122&scoped=true&"
import script from "./ActivityForm.vue?vue&type=script&lang=ts&"
export * from "./ActivityForm.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityForm.vue?vue&type=style&index=0&id=2c868122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c868122",
  null
  
)

export default component.exports